module.exports = __webpack_public_path__ + "static/img/about1_2.70296681.jpg";